import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-ycombinator',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Y Combinator icon</title><path d="M0 24V0h24v24H0zM6.951 5.896l4.112 7.708v5.064h1.583v-4.972l4.148-7.799h-1.749l-2.457 4.875c-.372.745-.688 1.434-.688 1.434s-.297-.708-.651-1.434L8.831 5.896h-1.88z"/></svg>`,
    styles: []
})
export class SimpleIconsYcombinatorComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F0652F';
    @Input() className: string = 'simple-icons-ycombinator'
    constructor() {}
    ngOnInit(): void {}
}
